import { render, staticRenderFns } from "./AiBookShopDailyManage.vue?vue&type=template&id=7f1a5fb4&scoped=true"
import script from "./AiBookShopDailyManage.vue?vue&type=script&lang=js"
export * from "./AiBookShopDailyManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1a5fb4",
  null
  
)

export default component.exports